// extracted by mini-css-extract-plugin
export default {"tx":"_5e8a34225a","line":"acad73a1ce"};